<template>

<core-panel>

	<template v-slot:head>

		<h1>Mechanic Affinity</h1>

		<p>All <b>{{ items.length }}</b> mechanics from this game in your universe.</p>

	</template>

	<template v-slot:body>

		<com-affinity-list v-if="items.length" :items="items" :baselines="baselines" colour="#1a9960" v-on:select="onSelect" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'
import comAffinityList from './../../../screen/profile/insights/game/AffinityList'

export default {

	mixins: [Panel],

	components: {
		'com-affinity-list': comAffinityList
	},

	data: function() {

		return {
			detail: 'affinity',
			items: [],
			baselines: null
		}

	},

	methods: {

		response: function(json) {

			this.baselines = json.affinity.baselines

			this.items = json.affinity.attributes.filter(function(a) { return a.type === 'mechanic' })

		},

		onSelect: function(item) {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsGameAffinityAttribute',
				id: this.data ? this.data.id : 0,
				attrType: item.type,
				attrId: item.id,
				child: true
			})

		}

	}

}

</script>
